const Index = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={`bg-surface rounded-md border border-border ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};
export default Index;
